import React, { useEffect, useRef, useState } from "react";
import {
  Card,
  Typography,
  Form,
  Input,
  // Select,
  Row,
  Col,
  Button,
  message,
  Spin,
  Switch,
  Select,
} from "antd";

import {
  BackwardOutlined,
  FormOutlined,
  RetweetOutlined,
} from "@ant-design/icons";
import { useSelector } from "react-redux";
import {
  capitalizeWords,
  formatDateWithSuffix,
} from "../../../../components/icons/ApplicationColor";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import axiosInstance from "../../../../api/Axios";
import {
  CUSTOMER_ID_FIELD,
  CUSTOMER_NAME_FIELD,
  FormInput,
} from "../../CAAdminCoursePages/courseForm";
import { CountryDropdown, RegionDropdown } from "react-country-region-selector";

import { PatternFormat } from "react-number-format";
const { Title, Paragraph } = Typography;

const { Option } = Select;
const Summary = ({ data1, loading, LoadUser, ImpersonateAccess }) => {
  console.log(data1);
  const history = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const isCAAdmin = location.pathname.includes("ca-admin");
  const userInfo = useSelector((state) => state.user);
  const classification = useSelector(
    (state) => state.orgdeatil.customerClassification
  );
  const [messageApi, contextHolder] = message.useMessage();
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedState, setSelectedState] = useState("");
  // const [tags, setTags] = useState([]);
  const [form] = Form.useForm();
  const CreateSuccessfull = (id) => {
    messageApi.open({
      type: "success",
      content: `${classification ? capitalizeWords(classification) : "Customer"} edit success.`,
      duration: 5,
    });
    LoadUser();
  };

  const CreateFailed = () => {
    messageApi.open({
      type: "error",
      content: `${classification ? capitalizeWords(classification) : "Customer"} edit failure`,
      duration: 5,
    });
  };
  const formRef = useRef();
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  const handleSubmit = async (values) => {
    const normalizedValues = Object.fromEntries(
      Object.entries(values).filter(
        ([key, value]) => value !== null && value !== undefined
      )
    );
    const { deactivate_on, due_date, description, ...rest } = normalizedValues;

    const finalValues = {
      ...rest,

      parent_key: userInfo?.data?.organization?.id,
    };

    console.log("Form submitted with values:", finalValues);
    try {
      const res = await axiosInstance.put(
        `customer/customers/?id=${id}`,
        finalValues,
        {
          headers: {
            "X-CSRFToken": csrfToken,
          },
        }
      );
      CreateSuccessfull(res.data.id);
    } catch (err) {
      CreateFailed();
    }
  };
  const loadForm = React.useCallback(() => {
    if (!loading && formRef.current) {
      const formValues = {
        name: data1?.name,
        client_id: data1?.client_id,
        description: data1?.description,
        address: data1?.address || "",
        industry: data1?.industry,
        zipcode: data1?.zipcode,
        city: data1?.city,
        enrollment_type: data1?.enrollment_type,
        org_type: data1?.org_type,
        ein: data1?.ein,
        country: data1?.country || "",
        access: data1?.access || false,
      };
      setSelectedCountry(data1?.country || "");
      setSelectedState(data1?.state || "");
      formRef.current.setFieldsValue(formValues);
    }
  }, [loading, data1]);

  const handleReset = () => {
    loadForm();
  };
  useEffect(() => {
    if (!loading && formRef.current) {
      loadForm();
    }
  }, [loading, data1, loadForm]);
  return (
    <Card
      style={{
        width: "100%",
        marginBottom: "10px",
      }}
      hoverable
    >
      <Spin spinning={loading}>
        {contextHolder}
        <Title level={4} style={{ letterSpacing: "0.5px" }}>
          {classification ? capitalizeWords(classification) : "Customer"}{" "}
          Information
        </Title>
        <Paragraph type="secondary">
          Edit and configure your existing{" "}
          {classification ? capitalizeWords(classification) : "Customer"} with
          the details below
        </Paragraph>

        <Form
          layout="vertical"
          onFinish={handleSubmit}
          name="complex-form"
          form={form}
          ref={formRef}
        //   onValuesChange={(_, allValues) => setFormValues(allValues)}
        >
          <Row gutter={16}>
            <FormInput
              field={{
                ...CUSTOMER_NAME_FIELD,
                span: 9,
                label: classification
                  ? `${capitalizeWords(classification)} Name`
                  : CUSTOMER_NAME_FIELD.label,
                placeholder: classification
                  ? `Enter ${capitalizeWords(classification)} name`
                  : CUSTOMER_NAME_FIELD.placeholder,
                rules: CUSTOMER_NAME_FIELD.rules.map((rule) => ({
                  ...rule,
                  message: classification
                    ? rule.message?.replace(
                      "Customer",
                      capitalizeWords(classification)
                    )
                    : rule.message,
                })),
              }}
            />
            <FormInput
              field={{
                ...CUSTOMER_ID_FIELD,
                span: 5,
                label: classification
                  ? `${capitalizeWords(classification)} ID`
                  : CUSTOMER_ID_FIELD.label,
                placeholder: classification
                  ? `Enter ${capitalizeWords(classification)} ID`
                  : CUSTOMER_ID_FIELD.placeholder,
                rules: CUSTOMER_ID_FIELD.rules.map((rule) => ({
                  ...rule,
                  message: classification
                    ? rule.message?.replace(
                      "Customer",
                      capitalizeWords(classification)
                    )
                    : rule.message,
                })),
              }}
            />
            <Col span={10}>
              <Form.Item label="Address">
                <Form.Item name="address" noStyle>
                  <Input
                    // className="my-form-input-antd-test"
                    placeholder={`Enter ${classification ? classification.toLowerCase() : "customer"}'s address`}
                  />
                </Form.Item>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={20}>
            <Col span={5}>
              <Form.Item label="Country">
                <Input.Group compact>
                  <Form.Item name="country" noStyle>
                    <CountryDropdown
                      // countryValueType="short"
                      //   disabled={!updateAuth}
                      value={selectedCountry}
                      onChange={(val) => setSelectedCountry(val)}
                      //   placeholder="Select County"
                      className="my-form-input-antd-test"
                      style={{
                        height: "3rem",
                        border: "0.1rem solid gray",
                      }}
                    />
                  </Form.Item>
                </Input.Group>
              </Form.Item>
            </Col>
            <Col span={5}>
              <Form.Item label="State">
                <Input.Group compact>
                  <Form.Item name="state" noStyle>
                    <RegionDropdown
                      // countryValueType="short"
                      //   disabled={!updateAuth}
                      country={selectedCountry}
                      value={selectedState}
                      onChange={(val) => setSelectedState(val)}
                      className="my-form-input-antd-test"
                      style={{
                        height: "3rem",
                        border: "0.1rem solid gray",
                      }}
                    />
                  </Form.Item>
                </Input.Group>
              </Form.Item>
            </Col>
            <Col span={5}>
              <Form.Item label="City" name="city">
                <Input placeholder="Enter City" />
              </Form.Item>
            </Col>
            <Col span={5}>
              <Form.Item
                name="zipcode"
                label="ZIP/Postal Code"
                rules={[
                  {
                    pattern:
                      selectedCountry === "United Kingdom"
                        ? /^[0-9a-zA-Z]*$/
                        : /^[0-9]*$/,
                    message:
                      selectedCountry === "United Kingdom"
                        ? "Please enter valid characters only"
                        : "Please enter numbers only",
                  },
                  {
                    min:
                      selectedCountry === "United States" ||
                        selectedCountry === "India" ||
                        selectedCountry === "United Kingdom" ||
                        selectedCountry === ""
                        ? 5
                        : undefined,
                    max:
                      selectedCountry === ""
                        ? 5
                        : selectedCountry === "United States"
                          ? 5
                          : selectedCountry === "India"
                            ? 6
                            : selectedCountry === "United Kingdom"
                              ? 7
                              : undefined,
                    message: "Invalid postal code",
                  },
                ]}
              >
                <Input placeholder="zip code" />
              </Form.Item>
            </Col>
            <Col span={3}>
              <Form.Item label="EIN/Tax ID">
                <Form.Item
                  name="ein"
                  noStyle
                  rules={[
                    {
                      pattern: /^\d{2}-\d{7}$/,
                      message: "EIN format req xx-xxxxxxx",
                    },
                  ]}
                >
                  <PatternFormat
                    //  disabled={!updateAuth}
                    format="##-#######"
                    className="my-form-input-antd-test"
                    style={{
                      paddingTop: "0.57rem",
                      paddingBottom: "0.57rem",
                      paddingLeft: "0.7rem",
                      borderRadius: "0.5rem",
                      border: "0.1rem solid gray",
                    }}
                    placeholder={" xx-xxxxxxx"}
                  />
                </Form.Item>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={7}>
              <Form.Item label="Industry" name="industry">
                <Input
                  placeholder={`Enter ${classification ? capitalizeWords(classification) : "Customer"} Industry`}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                label={`${classification ? capitalizeWords(classification) : "Customer"} Type`}
                name="org_type"
              >
                <Select placeholder="Select Type">
                  <Option value="non-profit">Non Profit</Option>
                  <Option value="profit">Profit</Option>
                  <Option value="Local Government">Local Government</Option>
                  <Option value="Individual">Individual</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label="Enrollment Type" name="enrollment_type">
                <Select placeholder="Select Enrollment Type">
                  <Option value="Organization">Organization</Option>
                  <Option value="Individual Instructor">
                    Individual Instructor
                  </Option>
                  <Option value="Training Company">Training Company</Option>
                  <Option value="Consultant Company">Consultant Company</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={5}>
              <Form.Item
                label="Portal Access"
                name="access"
                valuePropName="checked"
              >
                <Switch checkedChildren="Yes" unCheckedChildren="No" />
              </Form.Item>
            </Col>
          </Row>{" "}{false &&
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  label={`${classification ? capitalizeWords(classification) : "Customer"} Description`}
                  name="description"
                >
                  <Input.TextArea rows={4} placeholder="Enter description" />
                </Form.Item>
              </Col>
            </Row>
          }
          <div
            className="group-1-box"
            style={{
              paddingTop: "0rem",
              paddingLeft: "0px",
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
            }}
          >
            <div>
              <div style={{ display: "inline-block" }}>
                <Form.Item label=" " colon={false}>
                  <Button
                    type="text"
                    htmlType="button"
                    style={{
                      background: "#D3D3D3",
                    }}
                    onClick={() => {
                      history(
                        isCAAdmin
                          ? "/ca-admin/trainery-learn/bundles/listing"
                          : "/trainery-learn/courses/listing"
                      );
                    }}
                  >
                    <BackwardOutlined />
                    Back
                  </Button>
                </Form.Item>
              </div>

              <div style={{ display: "inline-block", marginLeft: "16px" }}>
                <Form.Item label=" " colon={false}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="save-update-btn"
                    loading={loading}
                  >
                    Update
                    <FormOutlined />
                  </Button>
                </Form.Item>
              </div>
              <div style={{ display: "inline-block", marginLeft: "16px" }}>
                <Form.Item label=" " colon={false}>
                  <Button
                    type="text"
                    htmlType="button"
                    onClick={handleReset}
                    style={{
                      background: "#D3D3D3",
                    }}
                  >
                    Reset
                    <RetweetOutlined />
                  </Button>
                </Form.Item>
              </div>
            </div>
          </div>
        </Form>
      </Spin>
    </Card>
  );
};

export default Summary;
